import styled from 'styled-components'
import { fontType, mediaQuery, toRem } from '../../styles/functions'

export const Container = styled.div`
	background-color: ${({ theme }) => theme.COLORS.download_background};
	padding: 48px 36px;
	display: flex;
	width: 100%;
	justify-content: center;

	${mediaQuery('sm')(`
	    padding: 48px 0;
    `)}
`

export const Content = styled.div`
	width: 100%;
	max-width: 1100px;
	display: flex;

	${mediaQuery('md')(`
        flex-direction: column;
    `)}
`

export const ImageContainer = styled.div`
	width: 100%;
	display: flex;
	justify-content: center;

	${mediaQuery('md')(`
        margin-bottom: 16px;
    `)}
`

export const Phone = styled.img`
	height: 400px;

	${mediaQuery('md')(`
       height: 300px
    `)}
`

export const Infos = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
`

export const DownloadMessage = styled.p`
	${fontType(1)}
	color: ${({ theme }) => theme.COLORS.BLACK};
	font-size: ${toRem(32)};
	text-align: left;
	margin-bottom: 76px;

	${mediaQuery('md')(`
        text-align: center;
    `)}
`

export const BadgesContainer = styled.div`
	width: 100%;
	display: flex;
	gap: 16px;

	${mediaQuery('md')(`
        justify-content: center;
    `)}

	${mediaQuery('xs')(`
	    flex-direction: column;
        align-items: center;
    `)}
`

export const Badges = styled.img`
	height: 56px;
`
